module.exports = __webpack_public_path__ + "static/shifts-hero-1-6aa93876d4c940e2466062d8b18a0750.png";